import { render, staticRenderFns } from "./HeaderDetail.vue?vue&type=template&id=78ab2442&"
import script from "./HeaderDetail.vue?vue&type=script&lang=js&"
export * from "./HeaderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports